import { PortfolioPageSectionBadge } from "@/components/portfolio/portfolio-page/PortfolioPageSectionBadge";
import { CardDescription, CardTitle } from "@/components/ui/Card";
import { PortfolioPageInsightItem } from "@/components/portfolio/portfolio-page/PortfolioPageInsightItem";
import {
  ClipboardDocumentCheckIcon,
  InboxStackIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import { useAppContext } from "@/context/AppContext";
import { useLanguage } from "@/context/LanguageContext";
import { getEstateLimit } from "@/utils/membershipLimits";
import { Panel } from "@/components/ui/Panel";

type PortfolioOverviewContextPanelProps = {
  estateCount: number;
  activeViewLabel: string;
  activeViewDescription: string;
};

export function PortfolioOverviewContextPanel({
  estateCount,
  activeViewLabel,
  activeViewDescription,
}: PortfolioOverviewContextPanelProps) {
  const { userInfoGlobal } = useAppContext();
  const estateLimit = getEstateLimit(userInfoGlobal?.membership);
  const { language } = useLanguage();
  const copy = {
    cs: {
      currentContext: "Aktuální kontext",
      watchdogCount: "Počet nemovitostí",
      of: "z",
    },
    en: {
      currentContext: "Current context",
      watchdogCount: "Number of watchdogs",
      of: "of",
    },
  }[language];

  return (
    <Panel>
      <div className="space-y-1">
        <PortfolioPageSectionBadge type={"dark"}>
          {copy.currentContext}
        </PortfolioPageSectionBadge>
      </div>

      <div className="mt-4 space-y-2">
        <PortfolioPageInsightItem
          icon={ClipboardDocumentCheckIcon}
          title={copy.watchdogCount}
          text={
            <span className={"text-lg"}>
              {estateCount}
              {estateLimit != null ? (
                <span className="text-xs ">
                  {" "}
                  {copy.of} {estateLimit}
                </span>
              ) : null}
            </span>
          }
        />

        <PortfolioPageInsightItem
          icon={InboxStackIcon}
          title={activeViewLabel}
          text={activeViewDescription}
        />
      </div>
    </Panel>
  );
}
